const { Application } = Shopware;

Application.addServiceProviderDecorator('searchTypeService', (searchTypeService) => {
    searchTypeService.upsertType('tdes_synonym', {
        entityName: 'tdes_synonym',
        placeholderSnippet: 'TopdataEnhancedSearchSW6.topdata-es-synonym.searchPlaceholder',
        listingRoute: 'topdata.es.synonym.list',
        hideOnGlobalSearchBar: true,
    });

    return searchTypeService;
});
